/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { MdArrowBack, MdSearch } from "react-icons/md";
import HomeService from "../../../services/home.service";

const ViewContent = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const item = state?.item || {};

  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const timerRef = useRef(null);

  const load = useCallback(
    async (currentSearch = search) => {
      try {
        const res = await HomeService.admin.viewContent({
          package_id: item.id,
          search: currentSearch,
        });
        setData(res.data || []);
      } catch (error) {
        console.error(error);
        toast.error("Error al cargar el contenido");
      } finally {
        setLoading(false);
      }
    },
    [item.id, search],
  );

  useEffect(() => {
    load();
  }, []);

  const handleSearch = (e) => {
    const val = e.target.value;
    setSearch(val);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      load(val);
    }, 1000);
  };

  return (
    <div className="max-w-6xl mx-auto py-6 px-4 md:px-8">
      {/* HEADER / INFO BL */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-6">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-1 text-sm font-bold text-[#1D3B8B] hover:underline mb-4"
        >
          <MdArrowBack size={18} />
          <span>Volver</span>
        </button>
        <h1 className="text-xl font-bold text-gray-900 uppercase mb-1">
          Contenido de: {item.number || "N/A"}
        </h1>
        <p className="text-sm font-semibold text-purple-600 uppercase mb-6">
          {item.code || ""}
        </p>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-gray-100 pt-6">
          <div className="w-full md:w-1/2 lg:w-1/3">
            <label className="block text-xs font-bold text-gray-600 uppercase mb-2">
              Cod. Cliente o RIF
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <MdSearch size={20} className="text-gray-400" />
              </div>
              <input
                type="text"
                placeholder="Buscar por cliente"
                value={search}
                onChange={handleSearch}
                className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-xl bg-white shadow-sm focus:ring-2 focus:ring-[#1D3B8B] focus:border-transparent outline-none transition-all text-sm"
              />
            </div>
          </div>
        </div>
      </div>

      {/* TABLA DE CONTENIDO */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-600 whitespace-nowrap min-w-full">
            <thead className="text-xs text-gray-500 uppercase bg-gray-50/80 border-b border-gray-100">
              <tr>
                <th className="px-4 py-3 font-semibold">CTN</th>
                <th className="px-4 py-3 font-semibold min-w-[200px]">
                  PRODUCTO
                </th>
                <th className="px-4 py-3 font-semibold">QTY</th>
                <th className="px-4 py-3 font-semibold">KG</th>
                <th className="px-4 py-3 font-semibold">CM</th>
                <th className="px-4 py-3 font-semibold">CM</th>
                <th className="px-4 py-3 font-semibold">CM</th>
                <th className="px-4 py-3 font-semibold">M3</th>
                <th className="px-4 py-3 font-semibold">KG FINAL</th>
                <th className="px-4 py-3 font-semibold min-w-[200px]">
                  CLIENTE
                </th>
                <th className="px-4 py-3 font-semibold min-w-[200px]">
                  TRACKING
                </th>
                <th className="px-4 py-3 font-semibold">FECHA</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {loading && data.length === 0 && (
                <tr>
                  <td
                    colSpan="12"
                    className="px-6 py-8 text-center text-[#1D3B8B] font-medium"
                  >
                    Cargando...
                  </td>
                </tr>
              )}

              {!loading && data.length === 0 && (
                <tr>
                  <td
                    colSpan="12"
                    className="px-6 py-8 text-center text-gray-400"
                  >
                    No se han encontrado registros
                  </td>
                </tr>
              )}

              {data.map((row, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50/50 transition-colors"
                >
                  <td className="px-4 py-3">{row.ctn}</td>
                  <td className="px-4 py-3 font-medium text-gray-900">
                    {row.name}
                  </td>
                  <td className="px-4 py-3">{row.qty}</td>
                  <td className="px-4 py-3">{row.kg}</td>
                  <td className="px-4 py-3">{row.cm_1}</td>
                  <td className="px-4 py-3">{row.cm_2}</td>
                  <td className="px-4 py-3">{row.cm_3}</td>
                  <td className="px-4 py-3">{row.m3}</td>
                  <td className="px-4 py-3">{row.final_kg}</td>
                  <td className="px-4 py-3">
                    {row.user?.code || row.temp_user_code || "-"}
                  </td>
                  <td className="px-4 py-3">{row.tracking}</td>
                  <td className="px-4 py-3">{row.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ViewContent;
